<template>
  <div>
    <div class="auth-page__form__header">
      <h2>Log In to FetchRev WiFi</h2>
    </div>
    <form
      @submit.prevent="handleSubmit()"
      class="auth-page__form__body"
    >
      <div
        :class="{'has-error': $v.email.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputEmail"
        >Email</label>
        <input
          autofocus
          class="form-control"
          id="inputEmail"
          placeholder="Email address"
          type="email"
          v-model.trim="$v.email.$model"
        >
        <small
          class="error"
          v-show="$v.email.$error"
        >
          <template v-if="!$v.email.required">Email is required.</template>
          <template v-else-if="!$v.email.email">Invalid email.</template>
        </small>
      </div>
      <div
        :class="{'has-error': $v.password.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputPassword"
        >Password</label>
        <input
          class="form-control"
          id="inputPassword"
          placeholder="Password"
          type="password"
          v-model="$v.password.$model"
        >
        <small
          class="error"
          v-show="$v.password.$error"
        >
          <template v-if="!$v.password.required">Password is required.</template>
          <template v-else>
            Minimum 8 characters with at least 1 letter,
            1 number and 1 special character
          </template>
        </small>
      </div>
      <div class="auth-page__form__submit-row">
        <router-link to="forgot-password">Forgot Password</router-link>
        <div>
          <span class="alternate-auth-link">Don't have account?
            <router-link to="signup">Create Account</router-link>
          </span>
          <button
            @click="handleSubmit()"
            class="btn btn-brand-primary"
            type="button"
          >Log In</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { required, minLength, email } from 'vuelidate/lib/validators';
import passwordComplexity from '@/validators/password-complexity';

export default {
  name: 'login-form',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(8),
      passwordComplexity,
    },
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('requestAuth', { email: this.email, password: this.password }).then(() => {
          this.$router.push('/');
        }).catch((err) => {
          if (err.response.status === 401) {
            this.$toast('error', 'Incorrect Email Password Combination');
          } else {
            this.$toast('error', err.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
</style>
